
/*
 State
 */
export const mapSection3State = state => {
    return {
        sectionQuestions: state.structure.section[3].sectionQuestions,
    };
};